import Confetti from "react-confetti";

import { StakeLogo } from "../../Assets/Images";
import { useViewport } from "../../Contexts/ViewportContext";

export default function Shell({ email, children, onSupport, onSignOutClick, celebrate = false, centered = false, statusPage = false }) {
  const { width, height } = useViewport();
  return (
    <div className="instant-release">
      <div className="ir-header" role="banner">
        <StakeLogo className="ir-logo" aria-label="Stake" />
        <button className="ir-signout" type="button" onClick={onSignOutClick}>
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M6.2 2.5H3.4A1.4 1.4 0 0 0 2 3.9v8.2a1.4 1.4 0 0 0 1.4 1.4h2.8"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
            <path d="M7 8h7M11.2 5.2 14 8l-2.8 2.8" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>Sign Out</span>
          {email ? <span className="ir-signout-email">({email})</span> : null}
        </button>
      </div>
      {celebrate ? (
        <div className="ir-confetti" aria-hidden="true">
          <Confetti width={width} height={height} />
        </div>
      ) : null}
      <main className={`ir-main${centered ? " is-centered" : ""}${statusPage ? " is-status" : ""}`}>{children}</main>
      <button className="ir-chat" type="button" aria-label="Contact support" onClick={onSupport}>
        <svg width="26" height="26" viewBox="0 0 26 26" aria-hidden="true">
          <path
            d="M6 7.5A3.5 3.5 0 0 1 9.5 4h7A3.5 3.5 0 0 1 20 7.5v6A3.5 3.5 0 0 1 16.5 17H12l-4.2 3.2c-.7.5-1.8 0-1.8-.8V17A3.5 3.5 0 0 1 6 13.5v-6Z"
            fill="#171B26"
          />
        </svg>
      </button>
    </div>
  );
}
